import React from "react";
import range from "lodash/range";
import { YEAR_SELECTOR_RANGE, getMonthNames } from "./utils";
import { DatePickerHeaderProps, DatePickerHeaderService } from "./types";
import DateTimeHelper from "shared/utils/dateTimeHelper";

export default function useDatePickerHeaderService(props: DatePickerHeaderProps): DatePickerHeaderService {
  const currentYear = React.useMemo(() => new Date().getFullYear(), []);
  const years = React.useMemo(
    () => range(currentYear - YEAR_SELECTOR_RANGE, currentYear + YEAR_SELECTOR_RANGE, 1),
    [currentYear]
  );
  const months = React.useMemo(() => getMonthNames(), []);
  const [openYearSelector, setOpenYearSelector] = React.useState<boolean>(false);

  const selectedMonth = React.useMemo(
    () =>
      DateTimeHelper.formatDate({
        startDate: props.date,
        option: {
          showOnlyMonth: true
        }
      }),
    [props.date]
  );

  const selectedYear = React.useMemo(() => props.date.getFullYear(), [props.date]);

  const selectedYearIndex = React.useMemo(() => years.indexOf(selectedYear), [selectedYear, years]);

  const openYearSelectorHandler = React.useCallback(() => {
    setOpenYearSelector(val => !val);
  }, []);

  const changeYearHandler = React.useCallback(
    (year: number) => {
      props.changeYear(year);
      setOpenYearSelector(false);
    },
    [props]
  );

  return {
    years,
    months,
    selectedMonth,
    selectedYear,
    selectedYearIndex,
    openYearSelector,
    changeYearHandler,
    openYearSelectorHandler
  };
}
